import { useEffect } from 'react';
import urlTemplate from 'url-template';
import type { MonolithSurrenderDetails } from 'src/apis/monolith/types';
import { useAxios } from 'src/hooks/use-axios';

type HookConfig = {
  surrenderId: string;
};

type ExecuteProps = {
  url: string;
};

export function useSurrenderDetails({ surrenderId }: HookConfig) {
  const surrender = useAxios(
    (axios, baseConfig, { url }: ExecuteProps) =>
      axios.request<MonolithSurrenderDetails>({
        ...baseConfig,
        url,
      }),
    { neededOnPageLoad: true }
  );

  useEffect(() => {
    const url = urlTemplate
      .parse(`${PRISMA_CONFIG.monolithApiUrl}/surrender/{id}`)
      .expand({ id: surrenderId });

    surrender.execute({ url });

    // oxlint-disable-next-line exhaustive-deps
  }, [surrenderId]);

  return surrender;
}

export type SurrenderDetailsRequest = ReturnType<typeof useSurrenderDetails>;
